import { Box, Stack, Typography } from "@mui/material";

/**
 * What the keyboard does on this screen.
 *
 * Stated rather than left to be discovered: select-on-tab and take-the-offered-
 * value are the two things that make transcribing a poor scan fast, and neither
 * announces itself. A reviewer who never finds them works the screen exactly as
 * slowly as before.
 *
 * Shown only while there is something to say — a document with no offered values
 * gets the tab hint alone, rather than a shortcut that does nothing.
 */
export function ManifestKeyboardHints({ hasOffers }: { hasOffers: boolean }) {
  const hints: { keys: string; label: string }[] = [
    { keys: "Tab", label: "next field, selecting what it holds" },
    ...(hasOffers ? [{ keys: "⌥↵", label: "take the offered value" }] : []),
  ];

  return (
    <Stack direction="row" spacing={2} sx={{ flexWrap: "wrap", rowGap: 0.5 }}>
      {hints.map((hint) => (
        <Stack key={hint.keys} direction="row" spacing={0.5} alignItems="center">
          <Box
            component="kbd"
            sx={{
              border: 1,
              borderColor: "divider",
              borderRadius: 0.5,
              px: 0.5,
              fontSize: "0.7rem",
              fontFamily: "inherit",
              color: "text.secondary",
            }}
          >
            {hint.keys}
          </Box>
          <Typography variant="caption" color="text.secondary">
            {hint.label}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
}
